// extracted by mini-css-extract-plugin
export default {"noteText":"noteText---pIkO0"};